import React, { useState } from "react";
import styled from "styled-components";
import LocationIcon from "./icon/LocationIcon";
import { getMyRegionADCountRequest, useCancelRegionAD, useGetMyRegionADCount } from "../service/ad.api";
import dayjs from "dayjs";
import ConfirmModal from "@src/components/popup/ConfirmModal";

const RegionADList = () => {
    const [requestData, setRequestData] = useState<getMyRegionADCountRequest>({});
    const [isOpenCancelModal, setIsOpenCancelModal] = useState<{ state: boolean; regionAdNo: number | null }>({
        state: false,
        regionAdNo: null,
    });

    const { data: myRegionADCount, refetch: refetchMyRegionADCount } = useGetMyRegionADCount(requestData);
    const { mutate: cancelRegionAD } = useCancelRegionAD();

    return (
        <Layout>
            {/* 광고 종료 모달 */}
            {isOpenCancelModal.state && (
                <ConfirmModal
                    onConfirm={() => {}}
                    resultMessage={
                        <CancelADModal>
                            <div className="title">광고를 종료하시겠습니까?</div>
                            <div className="content">
                                광고를 종료하면 매물 상세 또는 지도에서
                                <br />
                                더 이상 노출되지 않으며,
                                <br />
                                <br />
                                결제 금액은 환불되지 않습니다.
                            </div>
                        </CancelADModal>
                    }
                    cancelText="취소"
                    onCancel={() => setIsOpenCancelModal({ state: false, regionAdNo: null })}
                />
            )}

            <Selector>
                <div
                    className={`selectorItem ${requestData.adStatus === undefined ? "active" : ""}`}
                    onClick={() => setRequestData({})}
                >
                    전체({myRegionADCount?.countInfo?.totalCount.toLocaleString()})
                </div>
                <div
                    className={`selectorItem ${requestData.adStatus === "normal" ? "active" : ""}`}
                    onClick={() => setRequestData({ adStatus: "normal" })}
                >
                    광고중({myRegionADCount?.countInfo?.normalCount.toLocaleString()})
                </div>
                <div
                    className={`selectorItem ${requestData.adStatus === "closed" ? "active" : ""}`}
                    onClick={() => setRequestData({ adStatus: "closed" })}
                >
                    광고종료({myRegionADCount?.countInfo?.closedCount.toLocaleString()})
                </div>
            </Selector>

            <Counter>
                총{" "}
                {requestData.adStatus === "normal"
                    ? myRegionADCount?.countInfo?.normalCount.toLocaleString()
                    : requestData.adStatus === "closed"
                    ? myRegionADCount?.countInfo?.closedCount.toLocaleString()
                    : myRegionADCount?.countInfo?.totalCount.toLocaleString()}
                건
            </Counter>

            <ItemList>
                {myRegionADCount?.list.map((item) => {
                    const today = dayjs().startOf("day");
                    const expiredDate = dayjs(item.expiredAt).startOf("day");
                    const diff = expiredDate.diff(today, "day");

                    const statusText = diff >= 0 ? "광고중" : "광고종료";

                    return (
                        <Item key={item.regionAdNo}>
                            <div className="DayInfoBox">
                                <div className="StatusBox">
                                    <div className="status" style={{ color: statusText === "광고종료" ? "#8D8D8D" : "#0047FF" }}>
                                        {statusText}
                                    </div>
                                    <div className="date">
                                        {dayjs(item.startedAt).format("YYYY.MM.DD")} ~{" "}
                                        {dayjs(item.expiredAt).format("YYYY.MM.DD")}
                                    </div>
                                </div>

                                {/* <div
                                    className="endBtn"
                                    onClick={() => setIsOpenCancelModal({ state: true, regionAdNo: item.regionAdNo })}
                                >
                                    광고종료
                                </div> */}
                            </div>

                            <div className="LocationBox">
                                <LocationIcon />
                                <div>소재지 : {item.address.replaceAll(" ", " > ")}</div>
                            </div>
                        </Item>
                    );
                })}
            </ItemList>
        </Layout>
    );
};

const Layout = styled.div``;

const Selector = styled.div`
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .selectorItem {
        width: 100%;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 14px;

        border-bottom: 4px solid #dadada;

        color: #0b1024;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;

        &.active {
            border-bottom: 4px solid #0047ff;
            color: #0064ff;
            font-weight: 700;
        }
    }
`;

const Counter = styled.div`
    padding: 4px 14px;
    margin-top: 8px;

    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
`;

const ItemList = styled.div`
    width: 100%;
    height: calc(100vh - 220px);
    overflow-y: scroll;
    margin-top: 6px;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const Item = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px 0;
    margin: 0 14px;

    border-bottom: 1px solid #b8b8b8;

    .DayInfoBox {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .StatusBox {
            display: flex;
            flex-direction: row;
            gap: 4px;

            .status {
                color: #0047ff;
                font-size: 13px;
                font-weight: 700;
                line-height: 20px;
            }

            .date {
                color: #8d8d8d;
                font-size: 12px;
                font-weight: 400;
                line-height: 20px;
            }
        }

        .endBtn {
            padding: 2px 8px;

            border-radius: 4px;
            background: #f0f0f0;

            color: #8d8d8d;
            font-size: 13px;
            font-weight: 400;
            line-height: 20px;
        }
    }

    .LocationBox {
        display: flex;
        flex-direction: row;
        gap: 8px;
        padding: 4px 8px;

        border-radius: 6px;
        background: #f0f0f0;

        color: #0c002c;
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
    }
`;

const CancelADModal = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;

    .title {
        color: #0c002c;
        font-size: 16px;
        font-weight: 700;
        line-height: 26px;
    }

    .content {
        color: #0c002c;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
    }
`;

export default RegionADList;
